// extracted by mini-css-extract-plugin
export default {"tooltip":"Ep-z","sharingV2":"Fp-z","sharingIconsV2":"Gp-z","links":"Hp-z","link":"Ip-z","facebookV2":"Jp-z","twitterV2":"Kp-z","pinterestV2":"Lp-z"};